/** Value line height — keeps a single-line row at exactly 48px (14 + 20 + 14). */
export const VALUE_LINE_HEIGHT = 20;
